<template>
    <div class="body-small flex flex-col">
        <component :is="titleTag" class="text-ink">{{ t("teamPage.pendingTitle") }}</component>
        <p class="text-ink-muted">
            {{
                report.minimum_result_count
                    ? t("teamPage.pendingUnlock", { minimum: report.minimum_result_count, count: report.result_count })
                    : t("teamPage.pendingUnlockUnknown", { count: report.result_count })
            }}
        </p>
        <p class="text-ink-muted">{{ t("teamPage.pendingYoursCounts") }}</p>
    </div>
</template>
<script setup lang="ts">
import type { TeamPerspectiveReport } from "~vue/api/generated/team-perspective";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

// Under Overview's "Status" heading the title is plain text; where the card stands alone (Breakdown) it is the
// heading, so screen-reader users can still find the pending status by heading navigation.
const { report, standalone = false } = defineProps<{ report: TeamPerspectiveReport; standalone?: boolean }>();
const titleTag = computed(() => (standalone ? "h3" : "p"));
const { t } = useI18n();
</script>
